var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "164px",
    height: "164px",
    viewBox: "0 0 164 164",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphic-content") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphic-content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphic-learners"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 82,
    cy: 82,
    r: 82
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(32.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    cx: 52,
    cy: 62,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,70.5 L103.5,70.5 L103.5,2.5 L4,2.5 C3.17157288,2.5 2.5,3.17157288 2.5,4 L2.5,70.5 Z",
    id: "Rectangle",
    stroke: "#0D0D0D",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,52.5 L103,52.5",
    id: "Line-5",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.343372,113.5 C76.951421,117.027728 75.844843,120.040209 74,122.5 C72.6891412,124.247812 70.6039033,126.237704 67.727768,128.5 L100.793991,128.5 C97.6222345,126.196386 95.3824079,124.229963 94.047828,122.561738 C92.1517499,120.19164 91.031105,117.157716 90.6467597,113.5 L77.343372,113.5 Z",
    id: "Rectangle",
    stroke: "#000000",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 38,
    y: 48,
    width: 92,
    height: 42
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(56.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#266395",
    cx: 15.5,
    cy: 16.5,
    r: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2954967,9.75188976 L14.613865,27.0176226 L23.8112945,26.0755471 L32.6206069,27.0254043 L24.2954967,9.75188976 Z",
    id: "Triangle",
    stroke: "#000000",
    strokeWidth: 4,
    transform: "translate(23.485118, 17.411673) rotate(-43.000000) translate(-23.485118, -17.411673) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5,25.5 L37,31.5",
    id: "Line-2",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.b057745351a33e3dccf05cac538e88e4.svg";
export { ForwardRef as ReactComponent };